import React from 'react';

import {
  GatekeepingFiltersContextProvider,
  gatekeepingDefaultFilters,
} from 'modules/gatekeeping/filters/context';

import { GatekeepingUIContextProvider } from 'modules/gatekeeping/ui-context';

import { GatekeepingServiceContext } from 'modules/gatekeeping/service';

const GatekeepingProvider = ({ children }) => {
  return (
    <GatekeepingFiltersContextProvider defaultFilters={gatekeepingDefaultFilters}>
      {({ filters }) => (
        <GatekeepingServiceContext.Provider value={{ filters }}>
          <GatekeepingUIContextProvider>{children}</GatekeepingUIContextProvider>
        </GatekeepingServiceContext.Provider>
      )}
    </GatekeepingFiltersContextProvider>
  );
};

export { GatekeepingProvider };
